export const taxesTranslations = {
  ar: {
    title: 'الضرائب',
    addNew: 'اضافة جديد',
    search: 'بحث',
    serial: 'التسلسل',
    name: 'الاسم',
    percentageValue: 'النسبة المئوية',
    onInvoiceType: 'نوع الفاتورة',
    onReceiptType: 'نوع الإيصال',
    onDocCreditType: 'نوع سند القبض',
    salesAccount: 'حساب المبيعات',
    purchaseAccount: 'حساب المشتريات',
    edit: 'تعديل',
    delete: 'حذف',
    copy: 'نسخ',
    paste: 'لصق',
    view: 'عرض',
    list: 'قائمة',
    save: 'حفظ',
    cancel: 'إلغاء',
    noTaxes: 'لا توجد ضرائب',
    loading: 'جاري تحميل الضرائب...',
    error: 'فشل تحميل الضرائب',
    saveSuccess: 'تم حفظ الضريبة بنجاح',
    saveError: 'فشل حفظ الضريبة',
    deleteSuccess: 'تم حذف الضريبة بنجاح',
    deleteError: 'فشل حذف الضريبة',
    copySuccess: 'تم نسخ الضريبة',
    pasteSuccess: 'تم لصق الضريبة بنجاح',
    pasteError: 'لا توجد ضريبة منسوخة',
    isActive: 'نشط',
    previous: 'السابق',
    next: 'التالي',
    page: 'صفحة',
    of: 'من',
    showing: 'عرض',
    to: 'إلى',
    results: 'نتيجة',
    selectTax: 'اختر الضريبة',
    searchTaxes: 'بحث في الضرائب...',
    selectType: 'اختر النوع',
    debit: 'مدين',
    credit: 'دائن',
    selectSalesAccount: 'اختر حساب المبيعات',
    selectPurchaseAccount: 'اختر حساب المشتريات',
    selectFromTree: 'اختر من الدليل الشجري',
    chartOfAccounts: 'دليل الحسابات',
    searchChartOfAccounts: 'ابحث في دليل الحسابات...',
    selectAccount: 'اختر حساب',
    hasChildren: 'يحتوي على أبناء',
    noAccounts: 'لا توجد حسابات',
    noSelectableAccounts: 'لا توجد حسابات قابلة للاختيار',
  },
  en: {
    title: 'Taxes',
    addNew: 'Add New',
    search: 'Search',
    serial: 'Serial',
    name: 'Name',
    percentageValue: 'Percentage',
    onInvoiceType: 'Invoice Type',
    onReceiptType: 'Receipt Type',
    onDocCreditType: 'Credit Doc Type',
    salesAccount: 'Sales Account',
    purchaseAccount: 'Purchase Account',
    edit: 'Edit',
    delete: 'Delete',
    copy: 'Copy',
    paste: 'Paste',
    view: 'View',
    list: 'List',
    save: 'Save',
    cancel: 'Cancel',
    noTaxes: 'No taxes',
    loading: 'Loading taxes...',
    error: 'Failed to load taxes',
    saveSuccess: 'Tax saved successfully',
    saveError: 'Failed to save tax',
    deleteSuccess: 'Tax deleted successfully',
    deleteError: 'Failed to delete tax',
    copySuccess: 'Tax copied',
    pasteSuccess: 'Tax pasted successfully',
    pasteError: 'No tax copied',
    isActive: 'Active',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    of: 'of',
    showing: 'Showing',
    to: 'to',
    results: 'results',
    selectTax: 'Select Tax',
    searchTaxes: 'Search taxes...',
    selectType: 'Select Type',
    debit: 'Debit',
    credit: 'Credit',
    selectSalesAccount: 'Select Sales Account',
    selectPurchaseAccount: 'Select Purchase Account',
    selectFromTree: 'Select from Tree',
    chartOfAccounts: 'Chart of Accounts',
    searchChartOfAccounts: 'Search chart of accounts...',
    selectAccount: 'Select Account',
    hasChildren: 'Has children',
    noAccounts: 'No accounts',
    noSelectableAccounts: 'No selectable accounts found',
  },
  fr: {
    title: 'Taxes',
    addNew: 'Ajouter nouveau',
    search: 'Rechercher',
    serial: 'Série',
    name: 'Nom',
    percentageValue: 'Pourcentage',
    onInvoiceType: 'Type de facture',
    onReceiptType: 'Type de reçu',
    onDocCreditType: 'Type de document de crédit',
    salesAccount: 'Compte de vente',
    purchaseAccount: 'Compte d\'achat',
    edit: 'Modifier',
    delete: 'Supprimer',
    copy: 'Copier',
    paste: 'Coller',
    view: 'Voir',
    list: 'Liste',
    save: 'Enregistrer',
    cancel: 'Annuler',
    noTaxes: 'Aucune taxe',
    loading: 'Chargement des taxes...',
    error: 'Échec du chargement des taxes',
    saveSuccess: 'Taxe enregistrée avec succès',
    saveError: 'Échec de l\'enregistrement de la taxe',
    deleteSuccess: 'Taxe supprimée avec succès',
    deleteError: 'Échec de la suppression de la taxe',
    copySuccess: 'Taxe copiée',
    pasteSuccess: 'Taxe collée avec succès',
    pasteError: 'Aucune taxe copiée',
    isActive: 'Actif',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    of: 'de',
    showing: 'Affichage',
    to: 'à',
    results: 'résultats',
    selectType: 'Sélectionner le type',
    debit: 'Débit',
    credit: 'Crédit',
    selectSalesAccount: 'Sélectionner le compte de vente',
    selectPurchaseAccount: 'Sélectionner le compte d\'achat',
    selectFromTree: 'Sélectionner dans l\'arborescence',
    chartOfAccounts: 'Plan comptable',
    searchChartOfAccounts: 'Rechercher dans le plan comptable...',
    selectAccount: 'Sélectionner le compte',
    hasChildren: 'Contient des enfants',
    noAccounts: 'Aucun compte',
    noSelectableAccounts: 'Aucun compte sélectionnable trouvé',
  },
}


